import { TouchEvent } from 'react';

export const preventSwipeOnScroll = (event: TouchEvent<HTMLDivElement>) => {
    event.stopPropagation();
};
